import { render, staticRenderFns } from "./CompareSettings.vue?vue&type=template&id=b5db0288&scoped=true&"
import script from "./CompareSettings.vue?vue&type=script&lang=ts&"
export * from "./CompareSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CompareSettings.vue?vue&type=style&index=0&id=b5db0288&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db0288",
  null
  
)

export default component.exports